import React, { createContext, useContext, useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const RECENT_KEY = "nauta_recent_users";
export const getRecentUsers = () => { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]"); } catch { return []; } };
export const removeRecentUser = (email) => localStorage.setItem(RECENT_KEY, JSON.stringify(getRecentUsers().filter((u) => u.email !== email)));
const rememberUser = (u) => {
  const list = [{ email: u.email, name: u.name, role: u.role }, ...getRecentUsers().filter((x) => x.email !== u.email)].slice(0, 6);
  localStorage.setItem(RECENT_KEY, JSON.stringify(list));
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged out, obj=user
  const [location, setLocation] = useState(localStorage.getItem("nauta_loc") || "sabornauta");
  const [theme, setTheme] = useState(localStorage.getItem("nauta_theme") || "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("nauta_theme", theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("nauta_loc", location);
  }, [location]);

  const refresh = async () => {
    if (window.location.hash?.includes("session_id=")) { setUser(false); return; }
    const t = localStorage.getItem("nauta_token");
    if (!t) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("nauta_token");
      setUser(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const loginWithToken = (data) => {
    localStorage.setItem("nauta_token", data.token);
    rememberUser(data.user);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return loginWithToken(data);
  };

  const logout = () => {
    localStorage.removeItem("nauta_token");
    setUser(false);
  };

  const can = (mod) => user && user.permissions && user.permissions.includes(mod);
  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <AuthContext.Provider value={{ user, login, loginWithToken, logout, can, location, setLocation, theme, toggleTheme, apiErr }}>
      {children}
    </AuthContext.Provider>
  );
}
